import React from 'react';
import { Button, Stack, Typography } from '@mui/material';

const STATUS_UNAVAILABLE = 'Status unavailable. Progress may be out of date.';

export default function RunStatusNotice({
  error,
  retry,
  fetching,
  message = STATUS_UNAVAILABLE,
  retryLabel = 'Retry status',
}) {
  if (!error || error.authHandled) return null;
  return (
    <Stack direction="row" alignItems="center" spacing={1} role="status" sx={{ flexWrap: 'wrap' }}>
      <Typography variant="caption" color="text.secondary">{message}</Typography>
      <Button size="small" onClick={() => retry()} disabled={fetching}>{retryLabel}</Button>
    </Stack>
  );
}
